export default "__VITE_ASSET__XtXuyEPF__"